// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body:not(.edit-mode) .page-update-notification {
  display: none !important;
}
.page-update-notification {
  padding: 1rem;
  text-align: center;
}
.page-update-notification__modal {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.page-update-notification__modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
}
.page-update-notification__modal-dialog {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 42rem;
  max-height: calc(100vh - 2rem);
  overflow-y: auto;
}
.page-update-notification__modal-content {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 2rem rgba(0, 0, 0, 0.2);
}
.page-update-notification__modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #d8dce2;
}
.page-update-notification__modal-header h3 {
  margin: 0;
}
.page-update-notification__modal-body {
  padding: 1.5rem;
}
.page-update-notification .page-update-send-test {
  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.25);
}
.page-update-notification__modal-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #d8dce2;
}
/*# sourceMappingURL=page-update-notification-widget.css.map */`, "",{"version":3,"sources":["webpack://./page-update-notification-widget.less","webpack://./wwwroot/css/components/page-update-notification-widget.less"],"names":[],"mappings":"AACA;EAEQ,wBAAA;ACDR;ADKA;EACI,aAAA;EACA,kBAAA;ACHJ;ADKI;EACI,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;ACHR;ADMI;EACI,kBAAA;EACA,QAAA;EACA,8BAAA;ACJR;ADOI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,gBAAA;ACLR;ADQI;EACI,gBAAA;EACA,qBAAA;EACA,4CAAA;ACNR;ADSI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;ACPR;ADCI;EASQ,SAAA;ACPZ;ADWI;EACI,eAAA;ACTR;ADxCA;EAqDQ,+CAAA;ACVR;ADaI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,6BAAA;ACXR;AACA,8DAA8D","sourcesContent":["\nbody:not(.edit-mode) {\n    .page-update-notification {\n        display: none !important;\n    }\n}\n\n.page-update-notification {\n    padding: 1rem;\n    text-align: center;\n\n    &__modal {\n        position: fixed;\n        inset: 0;\n        z-index: 1050;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 1rem;\n    }\n\n    &__modal-backdrop {\n        position: absolute;\n        inset: 0;\n        background: rgba(0, 0, 0, .5);\n    }\n\n    &__modal-dialog {\n        position: relative;\n        z-index: 1;\n        width: 100%;\n        max-width: 42rem;\n        max-height: calc(100vh - 2rem);\n        overflow-y: auto;\n    }\n\n    &__modal-content {\n        background: #fff;\n        border-radius: .5rem;\n        box-shadow: 0 .5rem 2rem rgba(0, 0, 0, .2);\n    }\n\n    &__modal-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 1rem;\n        padding: 1.25rem 1.5rem;\n        border-bottom: 1px solid #d8dce2;\n\n        h3 {\n            margin: 0;\n        }\n    }\n\n    &__modal-body {\n        padding: 1.5rem;\n    }\n\n    .page-update-send-test {\n        box-shadow: 1px 1px 3px 1px rgba(0,0,0,.25);\n    }\n\n    &__modal-footer {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: .75rem;\n        padding: 1rem 1.5rem;\n        border-top: 1px solid #d8dce2;\n    }\n}\n","body:not(.edit-mode) .page-update-notification {\n  display: none !important;\n}\n.page-update-notification {\n  padding: 1rem;\n  text-align: center;\n}\n.page-update-notification__modal {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n.page-update-notification__modal-backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n}\n.page-update-notification__modal-dialog {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 42rem;\n  max-height: calc(100vh - 2rem);\n  overflow-y: auto;\n}\n.page-update-notification__modal-content {\n  background: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 0.5rem 2rem rgba(0, 0, 0, 0.2);\n}\n.page-update-notification__modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid #d8dce2;\n}\n.page-update-notification__modal-header h3 {\n  margin: 0;\n}\n.page-update-notification__modal-body {\n  padding: 1.5rem;\n}\n.page-update-notification .page-update-send-test {\n  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.25);\n}\n.page-update-notification__modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #d8dce2;\n}\n/*# sourceMappingURL=page-update-notification-widget.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
